// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ySGyJ","scrollbars":"styles_scrollbars__WKd6h","slideInSearchBar":"styles_slideInSearchBar__ESwA9"};